import BaseAPI from '../api'
const path = 'dashboard'
export interface DashboardInterface {
    idDepartment?: number
    idFiscalYear?: string
    keywordLevel1?: string
    keywordLevel2?: string
    keywordLevel3?: string
    keywordLevel4?: string
    endDate?: string;
    startDate?: string;
}

export default class DashboardApi extends BaseAPI {

    static getDashboardSummaryDownload(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary/download`, { params: { ...props }, responseType: 'arraybuffer' },)
            .then((res) => res)
    }
    static getDashboardSummaryByFileExtention(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-file-extention`, { params: { ...props } })
            .then((res) => res)
    }
    static getDashboardSummaryByFileExtentionDownload(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-file-extention/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getDashboardSummaryByDocumentType(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-document-type`, { params: { ...props } })
            .then((res) => res)
    }
    static getDashboardSummaryByDocumentTypeDownload(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-document-type/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getDashboardSummaryByDepartment(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-department`, { params: { ...props } })
            .then((res) => res)
    }
    static getDashboardSummaryByDepartmentDownload(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-department/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getDashboardSummaryByFiscalyear(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-fiscalyear`, { params: { ...props } })
            .then((res) => res)
    }
    static getDashboardSummaryByFiscalyearDownload(props: DashboardInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-fiscalyear/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }

}